import { render, staticRenderFns } from "./thaiDessert.vue?vue&type=template&id=586a7b65"
import script from "./thaiDessert.vue?vue&type=script&lang=js"
export * from "./thaiDessert.vue?vue&type=script&lang=js"
import style0 from "./thaiDessert.vue?vue&type=style&index=0&id=586a7b65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports